import Loader from '../../components/loader/Loader'
import {
  useGetClientDataQuery,
  useGetClientPaymentPlanQuery,
} from '../../redux/clientData/apiClientData'
import { toast } from 'react-toastify'
import styles from './Home.module.css'
import { useLogoutMutation } from '../../redux/auth/apiAuth'
import { setLogout } from '../../redux/auth/authSlice'
import { useDispatch } from 'react-redux'
import { useEffect, useState } from 'react'
import Viber from '../../components/viber/Viber'
import Search from '../../components/home/search/Search'
import Info from '../../components/home/info/Info'
import PaymentPlan from '../../components/home/paymentPlan/PaymentPlan'
import SearchHistory from '../../components/home/searchHistory/SearchHistory'
import VinSearch from '../../components/home/search/vinSearch/VinSearch'
import Documents from '../../components/home/documents/Documents'
import Notes from '../../components/home/notes/Notes'
import { useGetCurrencyRatesQuery } from '../../redux/data/apiData'
import { setShowReferencePrice } from '../../redux/searchSpares/sparesSlice'
import PopupDelivery from '../../components/modals/deliveryInfo/PopupDelivery'

const HomePage = () => {
  const [searchBtnSelected, setSearchBtnSelected] = useState(true)
  const [infoBtnSelected, setInfoBtnSelected] = useState(false)
  const [searchHistoryBtnSelected, setSearchHistoryBtnSelected] =
    useState(false)
  const [paymentPlanBtnSelected, setPaymentPlanBtnSelected] = useState(false)
  const [vinSearchBtnSelected, setVinSearchBtnSelected] = useState(false)
  const [documentsBtnSelected, setDocumentsBtnSelected] = useState(false)
  const [notesBtnSelected, setNotesBtnSelected] = useState(false)
  const [isPanelOpen, setIsPanelOpen] = useState(false)

  const { data: clientData, isLoading: isLoadingClientData } =
    useGetClientDataQuery()

  const { data: currencyRates, isLoading: isLoadingCurrencyRates } =
    useGetCurrencyRatesQuery()

  const { data: paymentPlan, isLoading: isLoadingPaymentPlan } =
    useGetClientPaymentPlanQuery()

  const [logout, { isLoading: isLoadingLogout }] = useLogoutMutation()

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isLoadingClientData) {
      if (clientData.currency !== 'eur') {
        dispatch(setShowReferencePrice(false))
      }
    }
  }, [isLoadingClientData])

  const handleLogout = async () => {
    try {
      await logout()
      dispatch(setLogout())
      window.location.reload()
    } catch (error) {
      toast.error('Сталась помилка...')
    }
  }

  const handleNavbarBtnClick = (name) => {
    const btnName = name
    if (btnName === 'Пошук') {
      setSearchBtnSelected(true)
      setInfoBtnSelected(false)
      setSearchHistoryBtnSelected(false)
      setPaymentPlanBtnSelected(false)
      setVinSearchBtnSelected(false)
      setDocumentsBtnSelected(false)
      setNotesBtnSelected(false)
    } else if (btnName === 'Інфо') {
      setSearchBtnSelected(false)
      setInfoBtnSelected(true)
      setSearchHistoryBtnSelected(false)
      setPaymentPlanBtnSelected(false)
      setVinSearchBtnSelected(false)
      setDocumentsBtnSelected(false)
      setNotesBtnSelected(false)
    } else if (btnName === 'Історія переглядів') {
      setSearchBtnSelected(false)
      setInfoBtnSelected(false)
      setSearchHistoryBtnSelected(true)
      setPaymentPlanBtnSelected(false)
      setVinSearchBtnSelected(false)
      setDocumentsBtnSelected(false)
      setNotesBtnSelected(false)
    } else if (btnName === 'План оплат') {
      setSearchBtnSelected(false)
      setInfoBtnSelected(false)
      setSearchHistoryBtnSelected(false)
      setPaymentPlanBtnSelected(true)
      setVinSearchBtnSelected(false)
      setDocumentsBtnSelected(false)
      setNotesBtnSelected(false)
    } else if (btnName === 'Пошук по VIN') {
      setSearchBtnSelected(false)
      setInfoBtnSelected(false)
      setSearchHistoryBtnSelected(false)
      setPaymentPlanBtnSelected(false)
      setVinSearchBtnSelected(true)
      setDocumentsBtnSelected(false)
      setNotesBtnSelected(false)
    } else if (btnName === 'Документи') {
      setSearchBtnSelected(false)
      setInfoBtnSelected(false)
      setSearchHistoryBtnSelected(false)
      setPaymentPlanBtnSelected(false)
      setVinSearchBtnSelected(false)
      setDocumentsBtnSelected(true)
      setNotesBtnSelected(false)
    } else if (btnName === 'Нотатки') {
      setSearchBtnSelected(false)
      setInfoBtnSelected(false)
      setSearchHistoryBtnSelected(false)
      setPaymentPlanBtnSelected(false)
      setVinSearchBtnSelected(false)
      setDocumentsBtnSelected(false)
      setNotesBtnSelected(true)
    }
  }

  const togglePanel = (e) => {
    e.stopPropagation()
    setIsPanelOpen((prev) => !prev)
  }

  const countPaymentTotalSum = (paymentPlan) => {
    if (!paymentPlan || paymentPlan.length === 0) {
      return 0
    }
    return paymentPlan.reduce((acc, payment) => {
      return acc + payment.sum
    }, 0)
  }

  const countCurrentPayment = (balance, paymentPlan) => {
    if (balance >= 0) {
      return 0
    }
    return Math.abs(balance) - Math.abs(countPaymentTotalSum(paymentPlan))
  }

  return (
    <div className="page">
      {isLoadingClientData && <Loader />}
      {isLoadingLogout && <Loader />}
      {isLoadingCurrencyRates && <Loader />}
      <div className={styles.homePageContainer}>
        <div className={styles.topContainer}>
          <div className={styles.clientCodeContainer}>
            <h3 className={styles.clientCodeText}>
              {clientData?.clientCode}
              <span onClick={handleLogout} className={styles.logOutText}>
                [ Вихід ]
              </span>
            </h3>
          </div>
          <div>
            <h2 className={styles.companyName}>СПРИНТ</h2>
          </div>
        </div>
        <div className={styles.mainContainer}>
          <div className={styles.clientDataContainer}>
            <div className={styles.nameContainer}>{clientData?.firstName}</div>
            <div className={styles.moneyBalanceContainer}>
              <span className={styles.balanceTextContainer}>
                {clientData?.balance > 0 ? 'Передплата: ' : 'Борг: '}
              </span>
              {Math.abs(clientData?.balance)}
            </div>
            {isLoadingPaymentPlan ? (
              <div className={styles.receivableBalanceContainer}>
                <span className={styles.warningTextSpec}>Протерміновано:</span>
              </div>
            ) : (
              <div className={styles.receivableBalanceContainer}>
                <span className={styles.balanceTextContainer}>
                  Протерміновано:
                </span>
                {countCurrentPayment(
                  clientData?.balance,
                  paymentPlan?.clientPaymentPlan
                ).toFixed(2)}
              </div>
            )}
            <div className={styles.currencyRateContainer}>
              <div>
                <span className={styles.currencyTextContainer}>USD:</span>
                <span>{currencyRates?.usd}</span>
              </div>
              <div>
                <span className={styles.currencyTextContainer}>EUR:</span>
                <span>{currencyRates?.eur}</span>
              </div>
            </div>
          </div>
          <div className={styles.contentContainer}>
            <div className={styles.menu}>
              <button
                onClick={() => handleNavbarBtnClick('Пошук')}
                className={
                  searchBtnSelected ? styles.menuBtnSelected : styles.menuBtn
                }
              >
                Пошук
              </button>
              <button
                onClick={() => handleNavbarBtnClick('Інфо')}
                className={
                  infoBtnSelected ? styles.menuBtnSelected : styles.menuBtn
                }
              >
                Інфо
              </button>
              <button
                onClick={() => handleNavbarBtnClick('Історія переглядів')}
                className={
                  searchHistoryBtnSelected
                    ? styles.menuBtnSelected
                    : styles.menuBtn
                }
              >
                Історія переглядів
              </button>
              <button
                onClick={() => handleNavbarBtnClick('План оплат')}
                className={
                  paymentPlanBtnSelected
                    ? styles.menuBtnSelected
                    : styles.menuBtn
                }
              >
                План оплат
              </button>
              <button
                onClick={() => handleNavbarBtnClick('Пошук по VIN')}
                className={
                  vinSearchBtnSelected
                    ? styles.menuBtnSelected
                    : styles.menuBtn
                }
              >
                Пошук по VIN
              </button>
              <button
                onClick={() => handleNavbarBtnClick('Документи')}
                className={
                  documentsBtnSelected
                    ? styles.menuBtnSelected
                    : styles.menuBtn
                }
              >
                Документи
              </button>
              <button
                onClick={() => handleNavbarBtnClick('Нотатки')}
                className={
                  notesBtnSelected ? styles.menuBtnSelected : styles.menuBtn
                }
              >
                Нотатки
              </button>
            </div>
            <div
              className={styles.searchContentContainer}
              style={{ display: searchBtnSelected ? 'block' : 'none' }}
            >
              <Search searchBtnSelected={searchBtnSelected} />
            </div>
            {infoBtnSelected && <Info rerender={infoBtnSelected} />}
            {paymentPlanBtnSelected && (
              <PaymentPlan rerender={paymentPlanBtnSelected} />
            )}
            {searchHistoryBtnSelected && (
              <SearchHistory rerender={searchHistoryBtnSelected} />
            )}
            {vinSearchBtnSelected && (
              <VinSearch />
            )}
            {documentsBtnSelected && (
              <Documents rerender={documentsBtnSelected} />
            )}
            {notesBtnSelected && (
              <Notes
                rerender={notesBtnSelected}
                onNavigateToSearch={() => handleNavbarBtnClick('Пошук')}
              />
            )}
          </div>
          <div className={styles.viberContainer}>
            <Viber />
          </div>
          <PopupDelivery togglePanel={togglePanel} isPanelOpen={isPanelOpen} />
        </div>
      </div>
    </div>
  )
}

export default HomePage
